import MusicAlbumEditForm3EditPopupViewVersionInput from './MusicAlbumEditForm3EditPopupViewVersionInput';
import MusicAlbumEditForm3EditPopupViewFeaturingArtistInput from './MusicAlbumEditForm3EditPopupViewFeaturingArtistInput';
import MusicAlbumEditForm3EditPopupViewLyricWriterInput from './MusicAlbumEditForm3EditPopupViewLyricWriterInput';
import MusicAlbumEditForm3EditPopupViewComposerInput from './MusicAlbumEditForm3EditPopupViewComposerInput';
import MusicAlbumEditForm3EditPopupViewLyricsInput from './MusicAlbumEditForm3EditPopupViewLyricsInput';
import MusicAlbumEditForm3EditPopupViewTitleInput from './MusicAlbumEditForm3EditPopupViewTitleInput';
import MusicAlbumEditForm3EditPopupViewPrductionAndEngineeringRoleInput from './MusicAlbumEditForm3EditPopupViewPrductionAndEngineeringRoleInput';
import MusicAlbumEditForm3EditPopupViewPerformanceRoleInput from './MusicAlbumEditForm3EditPopupViewPerformanceRoleInput';
import CustomButton from '../../../common/components/CustomButton';
import CustomOptionalIcon from '../../../common/components/CustomOptionalIcon';
import CustomTextInput from '../../../common/components/CustomTextInput';
import PopupContainer from '../../../common/components/PopupContainer';
import { FieldValidationErrorsType } from '../../../common/form/FrekulForm';

type MusicAlbumEditForm3EditPopupViewFieldName =
  'title'|'title_kana'|'title_en'|
  'has_version'|'version_type'|'version'|'version_kana'|'version_en'|
  'remix_name'|'remix_name_kana'|'remix_name_en'|'remixer_name'|'remixer_name_en'|
  'place'|'place_kana'|'place_en'|'city'|'city_kana'|'city_en'|'year'|'year_kana'|'year_en'|
  'has_music_featuring_artists'|['music_featuring_artists', number, 'name'|'name_en'|'name_kana']|
  'music_same_lyric_writer'|['music_lyric_writers', number, 'name'|'name_en']|
  'music_same_composer'|['music_composers', number, 'name'|'name_en']|
  ['music_production_and_engineering_roles', number, 'role'|'name'|'name_en']|
  ['music_performance_roles', number, 'role'|'name'|'name_en']|
  'is_inst'|'language'|'is_adult'|'isrc';
type MusicAlbumEditForm3EditPopupViewItemName =
  'music_featuring_artists'|'music_lyric_writers'|'music_composers'|
  'music_production_and_engineering_roles'|'music_performance_roles';


/**
 * 曲の編集ポップアップビュー
 *
 * @param {object} props プロパティ
 * @returns コンポーネント
 */
export default function MusicAlbumEditForm3EditPopupView({
  artistName,
  isIsrcFetchedFromTunecore,
  getValue,
  setValue,
  getErrors,
  getNumberOfItems,
  addItem,
  onSave,
  onCancel,
  performanceRoleOptions,
  productionAndEngineeringRoleOptions,
} : {
  artistName: string,
  isIsrcFetchedFromTunecore: boolean,
  getValue: (name: MusicAlbumEditForm3EditPopupViewFieldName) => string,
  setValue: (name: MusicAlbumEditForm3EditPopupViewFieldName, value: string) => void,
  getErrors: (name: MusicAlbumEditForm3EditPopupViewFieldName) => FieldValidationErrorsType,
  getNumberOfItems: (collection: MusicAlbumEditForm3EditPopupViewItemName) => number,
  addItem: (collection: MusicAlbumEditForm3EditPopupViewItemName, self: boolean) => void,
  onSave: () => void,
  onCancel: () => void,
  performanceRoleOptions: { title: string, value: string }[],
  productionAndEngineeringRoleOptions: { title: string, value: string }[],
}) {
  return (
    <PopupContainer
      title="曲情報の入力"
      onClose={() => onCancel()}
      // eslint-disable-next-line no-alert
      onBeforeClose={() => window.confirm('本当に閉じてもよろしいでしょうか？')}
    >
      <form className="cake_ajax_form">
        <div className="form__body">
          <MusicAlbumEditForm3EditPopupViewTitleInput
            getValue={getValue}
            setValue={setValue}
            getErrors={getErrors}
          />
          <MusicAlbumEditForm3EditPopupViewVersionInput
            getValue={getValue}
            setValue={setValue}
            getErrors={getErrors}
          />
          <MusicAlbumEditForm3EditPopupViewFeaturingArtistInput
            getValue={getValue}
            setValue={setValue}
            getErrors={getErrors}
            addItem={addItem}
            getNumberOfItems={getNumberOfItems}
          />
          <MusicAlbumEditForm3EditPopupViewLyricsInput
            getValue={getValue}
            setValue={setValue}
            getErrors={getErrors}
          />
          <span className="ttl_parent">
            曲の著作者
          </span>
          {getValue('is_inst') === '0' && (
            <MusicAlbumEditForm3EditPopupViewLyricWriterInput
              artistName={artistName}
              getValue={getValue}
              setValue={setValue}
              getErrors={getErrors}
              addItem={addItem}
              getNumberOfItems={getNumberOfItems}
              />
          )}
          <MusicAlbumEditForm3EditPopupViewComposerInput
            artistName={artistName}
            getValue={getValue}
            setValue={setValue}
            getErrors={getErrors}
            addItem={addItem}
            getNumberOfItems={getNumberOfItems}
          />
          <MusicAlbumEditForm3EditPopupViewPrductionAndEngineeringRoleInput
            getValue={getValue}
            setValue={setValue}
            getErrors={getErrors}
            addItem={addItem}
            getNumberOfItems={getNumberOfItems}
            productionAndEngineeringRoleOptions={productionAndEngineeringRoleOptions}
          />
          <MusicAlbumEditForm3EditPopupViewPerformanceRoleInput
            getValue={getValue}
            setValue={setValue}
            getErrors={getErrors}
            addItem={addItem}
            getNumberOfItems={getNumberOfItems}
            performanceRoleOptions={performanceRoleOptions}
          />
          {!isIsrcFetchedFromTunecore && (
            <dl>
              <dt>
                { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
                <label htmlFor="/">ISRCがある場合は入力してください</label>
                <CustomOptionalIcon />
              </dt>
              <dd>
                <CustomTextInput
                  placeholder=""
                  value={getValue('isrc')}
                  setValue={(value) => setValue('isrc', value)}
                  validationErrors={getErrors('isrc')}
                />
              </dd>
            </dl>
          )}
          <p className="top_line" />
          <ul>
            <li className="bt">
              <CustomButton type="cancel-split" onClick={() => onCancel()}>キャンセル</CustomButton>
              <CustomButton type="default-split" onClick={() => onSave()}>保存</CustomButton>
            </li>
          </ul>
        </div>
      </form>
    </PopupContainer>
  );
}

